import { useState } from 'react';
import { OptionIcon, TextField } from '@recargas-dominicanas/core/components';
import type { ICustomer } from '@recargas-dominicanas/core/types';
import { CustomerApi } from '@recargas-dominicanas/core/adminApi';
import { useForm } from '@recargas-dominicanas/core/hooks';
import { randomPassword } from '@recargas-dominicanas/core/utils';
import { Modal } from '../../../../components/modal/modal.component';
import { BusinessStore } from '../../../../store/businessStore';
import { style } from './edit-modal.module.css';

interface Props {
  open: boolean;
  businessId: number;
  customer: ICustomer;
  onClose: () => void;
}

export function EditModal(props: Props) {

  const {
    open,
    businessId,
    customer,
    onClose
  } = props;

  const [error, setError] = useState<string>();
  
  const form = useForm({
    username: customer.username ?? '',
    password: customer.password ?? ''
  }, [open]);

  async function handleSave() {

    if (!form.validate()) return;

    setError(undefined);

    try {

      await CustomerApi.updateUsernameAndPassword(customer.id, form.username.value, form.password.value);
      await BusinessStore.fetchById(businessId);

      handleClose();

    } catch {

      setError('Error actualizando cliente');
    }
  }

  function handleClose() {
    form.clear();
    setError(undefined);
    onClose();
  }

  return (
    <Modal
      open={open}
      title='Editar cliente'
      style={style.modal}
      secondaryButton='Guardar'
      error={error}
      onClose={handleClose}
      onSecondaryClick={handleSave}>
      <TextField 
        style={style.textField}
        label='Usuario'
        value={form.username.value}
        error={form.username.error}
        onChange={form.username.onChange}
        onBlur={form.username.onBlur}/>
      <TextField 
        style={style.password}
        label='Contraseña'
        value={form.password.value}
        error={form.password.error}
        onChange={form.password.onChange}
        onBlur={form.password.onBlur}
        rightIcon={
          <OptionIcon
            className={style.optionIcon}
            icon='casino'
            onClick={() => 
              form.password.update(randomPassword())
            }/>
        }/>
    </Modal>
  );
}
